/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import DefaultEmbedConstants from 'constants/DefaultEmbedConstants'
import DefaultEmbedQueries from 'queries/DefaultEmbedQueries'
import { patchOperations } from 'utils/PatchHelper'

const DefaultEmbedStore = Marty.createStore({
  id: 'DefaultEmbedStore',

  getInitialState() {
    return {
      embedByOrgId: {},
      patchStatus: null
    }
  },

  handlers: {
    fetchDefaultEmbedDone: DefaultEmbedConstants.DEFAULT_EMBED_FETCH_DONE,
    patchDefaultEmbedDone: DefaultEmbedConstants.DEFAULT_EMBED_PATCH_DONE,
    refreshDefaultEmbedDone: DefaultEmbedConstants.DEFAULT_EMBED_REFRESH_DONE,
    updateDefaultEmbed: DefaultEmbedConstants.UPDATE_CURRENT_EMBED,
    patchDefaultEmbedFailed: DefaultEmbedConstants.DEFAULT_EMBED_PATCH_FAILED,
    patchDefaultEmbedStart: DefaultEmbedConstants.DEFAULT_EMBED_PATCH_START
  },

  updateDefaultEmbed(update, message) {
    const currentOrgId = this.app.stores.OrgStore.getCurrentOrg().id
    const operations = patchOperations(update, this.state.embedByOrgId[currentOrgId].configuration)
    if (!_.isEmpty(operations)) {
      return this.app.queries.DefaultEmbedQueries.patchDefaultEmbed(operations, message)
    }
  },

  getOrFetchCurrentDefaultEmbed() {
    return this.fetch({
      id: 'fetchDefaultEmbed',
      dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
      locally() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        if (this.hasAlreadyFetched('fetchDefaultEmbed')) {
          return this.state.embedByOrgId[orgId]
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.queries.DefaultEmbedQueries.fetchDefaultEmbed(orgId)
      }
    })
  },

  getCurrentDefaultEmbed(orgId) {
    return this.state.embedByOrgId[orgId]
  },

  getLogoUrl() {
    return this.fetch({
      id: 'getLogoUrl',
      dependsOn: [this.getOrFetchCurrentDefaultEmbed()],
      locally() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return (this.state.embedByOrgId[orgId].configuration.theme != null ? this.state.embedByOrgId[orgId].configuration.theme.logoUrl : undefined) || ''
      }
    })
  },

  getDefaultEmbedForOrgId(orgId) {
    return this.fetch({
      id: `getDefaultEmbedForOrgId${ orgId }`,
      locally() {
        if (this.hasAlreadyFetched(`getDefaultEmbedForOrgId${ orgId }`)) {
          return this.state.embedByOrgId[orgId]
        }
      },
      remotely() {
        return this.app.queries.DefaultEmbedQueries.fetchDefaultEmbed(orgId)
      }
    })
  },

  getPatchStatus() { 
    return this.state.patchStatus
  },

  patchDefaultEmbedStart() {
    return this.state.patchStatus = 'PENDING'
  },

  fetchDefaultEmbedDone(orgId, embed) {
    return this.updateEmbed(orgId, embed)
  },

  patchDefaultEmbedDone(embed) {
    this.updateEmbed(embed.orgId, embed)
    return this.state.patchStatus = 'DONE'
  },

  patchDefaultEmbedFailed(embed) {
    this.updateEmbed(embed.orgId, embed)
    return this.state.patchStatus = 'DONE'
  },

  refreshDefaultEmbedDone(embed) {
    return this.updateEmbed(embed.orgId, embed)
  },

  updateEmbed(orgId, embed) {
    const embedByOrgId = _.cloneDeep(this.state.embedByOrgId)
    embedByOrgId[orgId] = embed
    return this.setState({ embedByOrgId })
  }
})

export default DefaultEmbedStore



// WEBPACK FOOTER //
// ./src/scripts/stores/DefaultEmbedStore.js